/**
 * @name 渲染表单组件
 */
import base from '../../base';
import FormBuildCopy from './form-build-copy';

FormBuildCopy.install = function(Vue) {
  Vue.use(base);
  Vue.component(FormBuildCopy.name, FormBuildCopy);
};

export default FormBuildCopy;
